import { PrivilegeEnum as a } from "@hprofits/shared/auth";
import { z as n } from "zod";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import "../common/errors/constants.js";
import { notFoundError as o, expectationFailedError as u } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as e } from "../swagger/tags.js";
import { UpdatePaymentInformationSchema as c, PaymentInformationSchema as i, PaymentInformationResponseSchema as s, BillingCountriesResponseSchema as p, AccountBalanceResponseSchema as l, AccountManagerResponseSchema as h, AccountPaymentIdParamSchema as r, AccountPayoutIdParamSchema as y, CreateAccountPaymentSchema as d, CreateAccountPaymentResultSchema as g, AccountPayoutsQuerySchema as A, AccountPayoutsResponseSchema as f, AccountPaymentsQuerySchema as C, AccountPaymentsResponseSchema as P, UpdateAccountProfileSchema as T, AccountProfileSchema as m } from "./schemas.js";
const I = {
  account: {
    profile: t().route({
      method: "GET",
      path: "/account/profile",
      summary: "Get the caller profile",
      tags: [e.ACCOUNT.name]
    }).output(m).errors(o("Account not found")),
    updateProfile: t().route({
      method: "PATCH",
      path: "/account/profile",
      summary: "Update the caller personal settings",
      tags: [e.ACCOUNT.name]
    }).input(T).output(m).errors(o("Account not found")),
    /** Payment transactions of the caller, one page. */
    payments: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/payments",
      summary: "List the caller payment transactions",
      tags: [e.ACCOUNT.name]
    }).input(C).output(P).errors({}),
    payouts: t([a.ReadPublisher]).route({
      method: "GET",
      path: "/account/payouts",
      summary: "List the payouts to the caller",
      tags: [e.ACCOUNT.name]
    }).input(A).output(f).errors({}),
    createPayment: t([a.WriteAdvert]).route({
      method: "POST",
      path: "/account/payments",
      summary: "Create a payment of the caller waiting for approval",
      tags: [e.ACCOUNT.name],
      successStatus: 201
    }).input(d).output(g).errors({
      ...u("Billing details are missing or the amount is below the minimum")
    }),
    invoice: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/payments/{paymentId}/invoice",
      summary: "Download the invoice PDF of a caller payment",
      tags: [e.ACCOUNT.name]
    }).input(r).output(n.file()).errors({
      ...o("Payment not found, not the caller, or its invoice is not ready yet")
    }),
    payoutInvoice: t([a.ReadPublisher]).route({
      method: "GET",
      path: "/account/payouts/{payoutId}/invoice",
      summary: "Download the invoice PDF of a payout to the caller",
      tags: [e.ACCOUNT.name]
    }).input(y).output(n.file()).errors({
      ...o("Payout not found, not the caller, or it has no invoice")
    }),
    deletePayment: t([a.WriteAdvert]).route({
      method: "DELETE",
      path: "/account/payments/{paymentId}",
      summary: "Delete a not yet approved payment of the caller",
      tags: [e.ACCOUNT.name],
      successStatus: 204
    }).input(r).output(n.void()).errors({
      ...o("Payment not found, not the caller, or already approved")
    }),
    /** Account manager assigned to the caller (`users.sales_owner`), or `null`. */
    manager: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/manager",
      summary: "Get the caller account manager",
      tags: [e.ACCOUNT.name]
    }).output(h).errors({}),
    /** Balance of the caller acting as an advertiser: payments minus ad spend; `null` for other roles. */
    balance: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/balance",
      summary: "Get the caller account balance",
      tags: [e.ACCOUNT.name]
    }).output(l).errors({}),
    billingCountries: t([a.ManageOwnBilling]).route({
      method: "GET",
      path: "/account/billing-countries",
      summary: "List the billing countries",
      tags: [e.ACCOUNT.name]
    }).output(p).errors({}),
    paymentInformation: t([a.ManageOwnBilling]).route({
      method: "GET",
      path: "/account/payment-information",
      summary: "Get the caller billing details",
      tags: [e.ACCOUNT.name]
    }).output(s).errors({}),
    updatePaymentInformation: t([a.ManageOwnBilling]).route({
      method: "PUT",
      path: "/account/payment-information",
      summary: "Save the caller billing details",
      tags: [e.ACCOUNT.name]
    }).input(c).output(i).errors({
      ...o("Billing country not found")
    })
  }
};
export {
  I as accountContract
};
//# sourceMappingURL=contract.js.map
